export enum TypeResource {
  VR,
  STANDARD,
  LIGHT,
}

export enum EDeclineType {
  None = "None",
  AllowConflict = "AllowConflict",
  BookingWindowInDay = "BookingWindowInDay",
  MaximumDurationInMinutes = "MaximumDurationInMinutes",
  MinimumDurationInMinutes = "MinimumDurationInMinutes",
  AllowRecurringMeeting = "AllowRecurringMeeting",
  NotPermissionToBooking = "NotPermissionToBooking",
  TentativeResource = "TentativeResource",
}

export enum ELoadMoreODataDefault {
  Top = 10,
  Skip = 0,
}

export enum ELoadMorePagingDefault {
  Page = 1,
  PageSize = 30,
}

export const ROOT: string = "root";

export enum ETypeFloorPlan {
  Circle = "circle",
  Rect = "rect",
  Triangle = "triangle",
  Polygon = "polygon",
  Itext = "i-text",
}

export enum AttendeeOfficeStatus {
  Free = 0,
  Busy = 1,
  Unknown = -1,
}
